<style lang='scss'>
	#ediotable tr td:nth-last-child(1),
	#ediotable tr th:nth-last-child(1) {
		border-right: 1px solid #e8e8e8 !important;
	}
	
	#ediotable .ant-table-bordered .ant-table-thead>tr>th,
	#ediotable .ant-table-bordered .ant-table-tbody>tr>td {
		border-right: unset;
	}
	
	#quanx_weitijao .grayman{
		font-size: .83rem;
	}
	#quanx_weitijao .paginationView {
		padding: 0.5rem 0;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}
	
	#quanx_weitijao .warp_gre {
		// width: .5rem;
		height: .5rem;
		line-height: .5rem;
		display: inline-block;
		position: relative;
		margin-right: .2rem;
	}
	
	#quanx_weitijao .ant-pagination-item {
		background-color: #fff;
		border-color: #bfbfbf;
		color: #999999;
		margin-right: 1rem;
	}
	
	#quanx_weitijao .ant-pagination-prev {
		margin-right: 1rem;
	}
	
	#quanx_weitijao .ant-pagination-item a {
		color: inherit;
	}
	
	#quanx_weitijao .ant-pagination-item-active {
		background-color: #f3f3f3;
		border-color: #d8d8d8;
		color: #000;
	}
	
	#quanx_weitijao .ant-pagination-prev .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-next .ant-pagination-item-link {
		background-color: #fff;
		color: #666666;
		border: 1px solid #bfbfbf;
	}
	
	#quanx_weitijao .ant-pagination-disabled a,
	#quanx_weitijao .ant-pagination-disabled:hover a,
	#quanx_weitijao .ant-pagination-disabled:focus a,
	#quanx_weitijao .ant-pagination-disabled .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-disabled:hover .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-disabled:focus .ant-pagination-item-link {
		background-color: #d8d8d8 !important;
		color: #fff !important;
	}
	
	#quanx_weitijao .pageTzView {
		display: flex;
		align-items: center;
		margin-left: 0.7rem;
	}
	
	#quanx_weitijao .look_g {
		font-size: .8rem;
		margin-bottom: .5rem;
		color: #0c8b97;
	
		div {
			display: inline-block;
			width: 10px;
			height: .9rem;
			position: relative;
			top: .1rem;
			margin-right: .2rem;
			border-left: 5px solid #0c8b97;
		}
	}
	
	#jurisdiction{
		
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		.ant-modal-root .ant-modal-close-x .anticon svg{
			right: -.5rem !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			/* display: inline-block;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;*/
			font-size: 0.94rem; 
			color: #0c8b97;
			/* min-width: 4rem;
			max-width: 6rem; */
			/* padding: .4rem 0 .6rem; */
			margin-bottom: .6rem;
			/* text-align: center; */
		}
		
		.gland{
			/* min-width: 4rem;
			max-width: 6rem; */
			margin-bottom: .6rem;
			/* text-align: center; */
			font-size: 0.94rem;
			/* display: inline-block;
			background-color: #0c8b97;
			color: #fff;
			border-right: 1px solid #e5e5e5; */
		}
		.isdivleft{
			border-left: 1px solid #d5d5d5;
		}
	}
	
	#jurisdiction_q>div{
		padding: 1px 0;
	}
	#quanx_weitijao::-webkit-scrollbar{
		display: none;
	}
	#quanx_weitijao{
		height: 58vh;
		overflow-y: auto;
	}
	#jurisdiction_q{
		.ant-collapse-content > .ant-collapse-content-box{
			padding: 4px 0;
		}
		.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header{
			padding: 17px 0;
		}
		.ant-collapse-borderless{
			background-color: #fff;
		}
		background-color: #fff;
		.main-mybody{
			padding: .5rem 0 0;
			/* overflow-y: auto; */
			/* min-height: 12rem; */
			/* max-height: 30rem; */
			
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 90%;
			height: 1px;
			border-top: .5px solid #ececec;
			/* margin-top: .5rem; */
			position: relative;
			    top: .2rem;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			margin-top: 1rem;
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}

</style>
<template>
	<div>
		<a-modal
		width='57rem'
		id='jurisdiction'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '10vh' }"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">權限編輯</div>
			</div>
			<div style="background-color: #fff;"   id='jurisdiction_q'>
				<div style="padding: 14px ;"  id='quanx_weitijao'>
				<a-collapse :bordered="false" expand-icon-position="right" v-model="activeKey">
					<a-collapse-panel :key="index+''" v-for='(items,index) in columnsData' v-model="collapsevalue">
						<div slot='header' class='div_w' style="display: flex;">
							<div style="font-size: .85rem;color: rgb(12 139 151);margin-right: 1rem;width: 7rem;font-size: .93rem;" >
								<img :src="items.pics" alt="" style="margin-right: 10px;width: 1.2rem;">
								<!-- <img :src="item.pics" alt="" style="width: 0.8rem;position: relative;top: -0.1rem;"> -->
								{{items.firstclassname}} </div>
								<div style="width: 90%;" v-if='activeKey.indexOf(String(index))== -1&&items.secondclass.length'>
									<div v-for='(val,a) in items.secondclass' style="margin-right: 20px;font-size: .935rem;color: #666;min-width: 4rem;display: inline-block;">{{val.secondclassname}}</div>
								</div>
							</div>
							<div v-if='items.secondclass.length' style="display: flex;border-top: 1px solid #d5d5d5;border-bottom: 1px solid #d5d5d5;flex-wrap: wrap;padding-top: .6rem;">
								<div v-for='(item,ind) in items.secondclass' style='cursor: pointer;'
								:key='ind + "0716" + index' v-if='!item.ishand'
								:class='item.state?"wland":"gland"' @click="handitem(index,ind)">
								<img :src="item.pics_open" alt="" style="width: 0.9rem;position: relative;top: -0.1rem;" v-if='item.state'>
								<img :src="item.pics_close" alt="" style="width: 0.9rem;position: relative;top: -0.1rem;" v-else>
									{{item.secondclassname}}
									<div style="display: inline-block;width: 2rem;text-align: center;color:#d5d5d5;" v-if='(ind+1)!==items.secondclass.length'>|</div>
									</div>
							</div>
								<div class='main-mybody' v-for='(value,inds) in items.secondclass' v-if='value.state&&items.secondclass.length' :key='inds+"2222" + index'>
											<a-row v-if='value["detailclass"].length' v-for='(item,ind) in value["detailclass"]' :key='ind+"1001" + index'>
												<a-row>
														<a-col :span='8' >
															<div class='warp_gre'>
																 <!-- value="uncheck" name="check" onclick="this.value=(this.value=='uncheck')?'checked':'uncheck'"> -->
																 <!-- @change="onChange(items.details)" default-value='1' -->
																<a-checkbox v-model='item.selected' :value="1">
																	<span class='grayman'>{{item.detail}}</span>
																</a-checkbox>
															</div>
														</a-col>
												</a-row>
												<div style="padding-left: 24px;">
													<div style="color: #666;width: 20%;display: inline-block;margin: 10px 0;font-size: .835rem;" v-for='(v,b) in item.remarklist' :key='b+"345"'>
														
														{{v}}
													</div>
												</div>
												<!-- <div class='main-wid main-wids' v-if='ind+1<item.remarklist.length'></div> -->
												<!-- <br v-if='ind+1<item.remarklist.length'> -->
											</a-row>
											<a-row v-if='value["detailclass"].length==0'>
													<a-col :span='4' >
														<span class='grayman'>暫無權限</span>
													</a-col>
													</a-row>
								</div>
					</a-collapse-panel>
				</a-collapse>
				</div>
				<div class='warp_daochu'>
					<div style="padding-left: .5rem;"></div>
					<div>
						<button class='btn1 btnx' @click='resetForm("1")'>保 存</button>
						<!-- <button class='btn1 btn2' @click='resetForm("2")'>提交</button> -->
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
		
	export default {
		name:'handhome',
		props:['itemobj','applyid','items'],
		components:{
			},
		data(){
			return {
				activeKey:[],
				val:'',
				columnsData: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 10, //每頁條目數
					revisistatus: '',
				},
				collapsevalue: [],
				aduit:true,
				tableData:[],
				picList:[],
				isname: '申請假期',
				visible:true,
				island: 2,
				titlearr:[
					{
						firstclassname:'證券交易',
						component:'',
						island:true
					},
					{
						firstclassname:'資產管理',
						component:'messagearr',
						island:false
					},
					{
						firstclassname:'人事財務',
						component:'',
						island:false
					},{
						firstclassname:'維護管理',
						component:'',
						island:false,
					},{
						firstclassname:'檔案權限',
						component:'',
						island:false,
					},
				]
			}
		},
		created() {
			let _this = this
			// setTimeout(()=>{
			// 	if(_this.itemobj.status == 2||(_this.itemobj.schedule == 4 && _this.itemobj.status == 0 && !_this.itemobj.aduit)){
			// 		_this.island = 'shenhelist'
			// 	}
			// },100)
		},
		mounted() {
		// this.moreEvent();
		this.getdate()
		},
		watch:{
			activeKey:{
				deep:true,
				immediate:true,
				handler(ev){
					// console.log(ev)
				}
			},
		},
		methods:{
			opendis(i){
				let str = false
				this.activeKey.map(ev=>{
					if(ev == i){
						str = true
					}
				})
				console.log(str)
				return str
			},
			getdate() {
				
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getAuthorizationList,
					data: {
						"userid": this.items.userid,
						// "firstid":this.islands
					}
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.columnsData = res.data.firstclass
						this.columnsData.map((ev,ind)=>{
							ev.secondclass.map((val,a)=>{
								if(a){
									val['state'] = false
								}else{
									val['state'] = true
								}
							})
						})
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			resetForm(){
				this.$ajax({
					method:'post',
					url:this.$api.newAuthor,
					data:{
						"userid": this.items.userid,
						// "firstid":this.islands,
						 firstclass: this.columnsData
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.$message.success('操作成功')
						// this.$emit('child',1)
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err=>{
					this.$message.waring(err.data.qmismsg)
				})
			},
			moreEvent(record=this.itemobj){
			            // token : _this.$store.state.token,
						this.$ajax({
							url:this.$api.getFirstidList,
							method:'post',
							data:{}
						}).then(res=>{
							console.log(res)
							this.titlearr = res.data.firstidListList
						}).catch(err=>{
							console.log(err)
						})
			},
			handitem(index,inds){
				let _this = this;
				this.columnsData[index]['secondclass'].map((val,a)=>{
					// _this.$set(_this.columnsData[index]['secondclass'][a],'state',a==inds)
					_this.$set(val,'state',a==inds)
				})
				this.$forceUpdate()
			},
			getdata(item,record = this.itemobj) {
				this.tableData = []
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.getAdminRemarks, {
					// admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.tableData = data.remarks
						if(data.remarks.length == 0){
							this.$message.warning('暫無審核記錄')
						}else{
							this.island = item.component;
						}
					} else {
						// this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					// console.log(err);
				});
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
